import { render, staticRenderFns } from "./Wxpublic.vue?vue&type=template&id=7308b71a"
import script from "./Wxpublic.vue?vue&type=script&lang=js"
export * from "./Wxpublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports